import { useMemo } from 'react'
import { useEnterpriseRepositoryAdaptor } from '../../../services/adaptors/enterpriseReportRepositoryAdaptor'

export const useGetEnterpriseReport = () => {
  const repository = useEnterpriseRepositoryAdaptor()
  const getEnterpriseReport = useMemo(() => repository.getEnterpriseReport, [])
  return { getEnterpriseReport }
}
